import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import sutherlandLogo from '../assets/img/sutherlandglobal.png';
import eventLogo from '../assets/img/Lumina-event.png';
import eSeallogo from '../assets/img/big-logo.png';
import confetti from "canvas-confetti";
import LUMINA_EVENT_CONFIG from "utilities/luminaEventConfig";

export function EventLuckyDraw() {
  const { city } = useParams();
  const eventDetails = LUMINA_EVENT_CONFIG[city?.toLowerCase()];
  const entryPassRef = useRef(null);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [loading, setLoading] = useState(false);
  const [kitValue, setKitValue] = useState(null);
  const [error, setError] = useState(null);
  const [isFlipping, setIsFlipping] = useState(false)

  const [canFlip, setCanFlip] = useState(false);
  const [shouldRunConfetti, setShouldRunConfetti] = useState(false);

  const runConfetti = () => {
    var count = 200;
    var defaults = {
      origin: { y: 0.7 },
      ticks: 600,
      gravity: 0.5,
      decay: 0.9,
      scalar: 1
    };

    function fire(particleRatio, opts) {
      confetti(
        Object.assign({}, defaults, opts, {
          particleCount: Math.floor(count * particleRatio)
        })
      );
    }

    fire(0.25, {
      spread: 26,
      startVelocity: 55
    });
    fire(0.2, {
      spread: 60
    });
    fire(0.35, {
      spread: 100,
      decay: 0.91,
      scalar: 0.8
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 25,
      decay: 0.92,
      scalar: 1.2
    });
    fire(0.1, {
      spread: 120,
      startVelocity: 45
    });
  };

  const handleValidate = async () => {
    if (!employeeId) return;
    setLoading(true);
    setError(null);

    const empCodeValue = employeeId;
    try {
      const response1 = await fetch("https://icapidilite-stg-prod.eseal.io/scoapi/empSungatiStatus", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          issue_type: "Validate",
          access_token: 'k2qeg2d7g6jt3svh',
          module_id: "4002",
          sutherland_emp_id: empCodeValue || null,
          status: "0"
        }),
      });

      if (!response1.ok) {
        throw new Error(`API error: ${response1.status}`);
      }

      const data1 = await response1.json();
      if (data1.Status !== 1 || !data1.Data || data1.Data.length === 0) {
        throw new Error(data1.Message || "Invalid response");
      }

      const empDetails = data1.Data[0];
      setKitValue(empDetails.Kit);
      setEmployeeName(empDetails.emp_name || "");

      if (data1.Status === 1 && empDetails.Kit === 0) {
        const response2 = await fetch("https://icapidilite-stg-prod.eseal.io/scoapi/empSungatiStatus", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            access_token: 'k2qeg2d7g6jt3svh',
            issue_type: "Kit",
            module_id: "4002",
            sutherland_emp_id: empCodeValue || null,
            status: "1"
          }),
        });

        if (!response2.ok) {
          throw new Error(`Second API error: ${response2.status}`);
        }

        const data2 = await response2.json();
        setCanFlip(true);
        setShouldRunConfetti(true);
      } else {
        setCanFlip(false);
        setShouldRunConfetti(false);
        setIsFlipping(false);
      }
    } catch (err) {
      setKitValue(null)
      setError('Invalid Employee ID. Please enter the correct one.' || "Failed to enroll");
      setCanFlip(false);
      setShouldRunConfetti(false);
      setIsFlipping(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canFlip && kitValue == 0) {
      setIsFlipping(true);
    } else {
      setIsFlipping(false);
    }
  }, [canFlip, kitValue]);

  useEffect(() => {
    if (isFlipping && shouldRunConfetti) {
      runConfetti();
      setShouldRunConfetti(false);
    }
  }, [isFlipping, shouldRunConfetti]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setError(null);
    if (name === "employeeId") {
      setEmployeeId(value);
    }
  };

  const handleBack = () => {
    setIsFlipping(false);
    setCanFlip(false);
    setError(null);
  };

  useEffect(() => {
    if (!employeeId) {
      handleBack();
    }
  }, [employeeId]);

  if (!eventDetails) {
    return (
      <div className="event-lucky-draw-page">
        <div className="event-container">
          <div className="error-message">
            Invalid event city. Please check the URL and try again.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="event-lucky-draw-page">
      <div className="event-container">
        {/* Left Panel - Credentials */}
        <div className="left-pane">
          <div className={`ticket-card ${isFlipping ? "flipped" : ""}`}>
            <div className="ticket-front">
              <div className="logo-container">
                <img src={sutherlandLogo} alt="Company Logo" />
              </div>
              <div className="form-section">
                <label htmlFor="employeeId" style={{ fontWeight: 'bold', marginBottom: '1rem', display: 'block' }}>
                  Enter Employee ID
                </label>
                <input
                  name="employeeId"
                  type="text"
                  placeholder="Emp. ID"
                  value={employeeId}
                  onChange={handleInputChange}
                />
                <button onClick={handleValidate} disabled={loading || !employeeId.trim()}>
                  {loading ? "Enrolling..." : "Enroll for lucky draw"}
                </button>
                {kitValue === 1 ? (
                  <div className="error-message" style={{ color: 'red' }}>
                    <span className="subtitle">
                      You have already enrolled for<br />
                      <strong>Today's Lucky Draw Event</strong>
                    </span>
                  </div>
                ) : error ? (
                  <div className="error-message" style={{ color: 'red' }}>
                    {error}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="ticket-back" ref={entryPassRef}>
              <div className="event-logo-block">
                <img src={eventLogo} alt="Lumina Logo" className="event-logo" />
                <div className="event-date">{eventDetails.date}</div>
              </div>

              <div className="celebration-card">
                <div className="winner-burst">🎉</div>
                <div className="congrats">
                  {kitValue === 0 && (
                    <>
                      Congratulations,
                      <div className="employee-name">{employeeName || employeeId}</div>
                      <span className="subtitle">
                        you have successfully enrolled for<br />
                        <strong>Today's Lucky Draw Event</strong>
                      </span>
                    </>
                  )}
                  <br />
                </div>
                <div className="winner-burst">🎉</div>
              </div>

              <div className="footer-info">
                <img src={sutherlandLogo} alt="Company Logo" className="footer-logo" />
                <p className="powered">
                  Developed by <img src={eSeallogo} alt="eSeal Logo" className="powered-logo" /> eSeal Team
                </p>
              </div>
              <div className="ticket-buttons">
                <button className="back-btn" onClick={handleBack}>Back</button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel - Event Details */}
        <div className="right-pane">
          <div className="event-card">
            <img src={eventLogo} className="logo-badge" alt="Lumina Logo" />
            <div className="event-title">SUTHERLAND DES Annual Day 2026 - {eventDetails.city}</div>
            <div className="event-tagline">An evening of sparkle and spirit!</div>
            <div className="event-info-block">
              <div className="info-row"><span className="emoji">📅</span><span className="label">{eventDetails.date}</span></div>
              <div className="info-row"><span className="emoji">⏰</span><span className="label">{eventDetails.time}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
